var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function MinusCircleIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12ZM7 12C7 11.4477 7.44911 11 7.9954 11H16.0046C16.5543 11 17 11.4439 17 12C17 12.5523 16.5509 13 16.0046 13H7.9954C7.44565 13 7 12.5561 7 12Z", fill: "" })));
}
export var MinusCircleIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: MinusCircleIconInner }, props))); };
//# sourceMappingURL=MinusCircleIcon.js.map